// extracted by mini-css-extract-plugin
export default {"page":"HomePage_page_utT5s"};